import { Close as CloseIcon } from "@mui/icons-material";
import {
  IconButton,
  Snackbar,
  Divider,
  Autocomplete,
  Box,
  Typography,
  TextField,
} from "@mui/material";
import axios from "axios";
import { t } from "i18next";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import API_Routes from "../../../../constants/api-routes";
import InputGroup from "react-bootstrap/InputGroup";
import {
  addFeedbackCustomerUrl,
  addFeedbackUrl,
  datePickerAppDate,
  getAreaByFeedbackTypeURL,
  getCustomerDepartmentAttributeMap,
  getFeedbackDescriptionTemplate,
  getFeedbackTypeListAll,
  getInternalDepartment,
  getInternalFeedbackDetailsURL,
  getOldFeedbackSPOCUrl,
  getProcessConditionURL,
  getSubAreaURL,
  minInputValueForClientField,
  secondary_theme_color,
} from "../../../../constants/constants";
import AutoCompleteMultiSelectDropdown from "../AutoCompleteMultiSelectDropdown";
import DatePickerComponent from "../DatePickerComponent";
import Dropdown from "../Dropdown";
import PageHeadContainer from "../PageHeadContainer";
import RichTextEditor from "../TextEditor/RichTextEditor";
import TextLabel from "../TextLabel";
import FileUpload from "../uploadFile";
import { uploadFeedbackAttachment } from "../../../../constants/constants";
import { apiHostUrl } from "../../../../constants/constants";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import TagOldFeedback from "../feedback/TagOldFeedback";
import useAxiosFetchData from "../../../hooks/useAxiosFetchData";
import DropdownInputWithLabel from "../DropdownInputWithLabel";
import { useRef } from "react";
import {
  checkImageSignatureAndSize,
  clearFileInput,
  clickFileInput,
//  handleFileChange,
  removeHTMLElements,
  postActionDataRefresh,
} from "../CommonUtils";
import { useDispatch } from "react-redux";
import { setResponsePendingReducer } from "../../../system/redux/reducers/ResponsePendingReducer";
import { Typeahead } from "react-bootstrap-typeahead";
import moment from "moment";
import { serialize } from "../TextEditor/TextSerializer";
import { updateEditorExternal } from "../TextEditor/RichTextEditor";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 13px;
  box-sizing: border-box;
  margin-top: 2rem;
`;
const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
  align-items: flex-start;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding-top: 2rem;
//   max-width:95%;
//   width: 100%;
//   margin: 0 auto;
// `

const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
export default function AddFeedbackModalCustomer({
  onModalCloseHandler,
  snackbarSwitchHandler,
  snackMsgHandler,
  setRefreshDashboard,
}) {
  const [dept, setDept] = useState("");
  const { csrfToken } = useSelector((state) => state.csrf);
  const { userId: bidderId } = useSelector((state) => state.role);
  const { roles, homeLink, userCurrRole } = useSelector((state) => state.role);

  const [payload1, setPayload1] = useState({
    serviceId:
      userCurrRole.department.id == 189 ? 112 : userCurrRole.department.id,
  });
  const headers = {
    "Content-Type": "application/json",
    "X-CSRF-TOKEN": csrfToken,
  };
  const newHeaders = headers;
  newHeaders["X-Csrf-Token"] = csrfToken;
  newHeaders["Content-Type"] = "application/json";
  const [oldFeedbacks, setOldFeedbacks] = useState([]);
  const [r, setR] = useState(0);
  const [initLoad, setInitLoad] = useState(true);
  const [oldFeedbackList, setOldFeedbackList] = useState([]);
  const [feedbackType, setFeedbackType] = useState(null);
  const [addFeedbackResult, setAddFeedbackResult] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(true);
  const [departmentAttributeMap, setDepartmentAttributeMap] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [feedbackTypeList, setFeedbackTypeList] = useState([
    { id: 100, desc: t("general.chart.legend.complaint") },
    //{ id: 103, desc: t("general.label.feedback.general.query") },
  ]);
  const [finalPayload, setFinalPayload] = useState({
    attributeList: [],
  });
  const [feedbackFile, setFeedbackFile] = useState("");
  const [filename, setFilename] = useState("");
  const [attributeMasterValueList, setAttributeMasterValueList] = useState([]);
  const [terminated, setTerminated] = useState(false);
  const [selectedValue, setSelectedValue] = useState([]);

  const [feedbackListPayload, setFeedbackListPayload] = useState({
    serviceId: homeLink === "/internal" || dept == 189 ? 112 : dept,
  });
  const [addFeedbackWithAreaEnable, setAddFeedbackWithAreaEnable] =
    useState(false);
  const [ftDone, setftDone] = useState(false);

  // const [addFeedbackWithAreaEnable, setAddFeedbackWithAreaEnable] =
  //   useState(null);
  const {
    response: feedbackTypeListResponse,
    fetchData: fetchFeedbackTypeList,
  } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getFeedbackTypeListAll}`,
    method: "POST",
    body: feedbackListPayload,
    headers: newHeaders,
    onLoad: false,
  });
  const [processConditionFetchPayload, setProcessConditionFetchPayload] =
    useState(null);
  const [processConditionId, setProcessConditionId] = useState(null);
  const [processConditionName, setProcessConditionName] = useState(null);
  const [masterAreaId, setMasterAreaId] = useState(null);
  const [masterAreaDescription, setMasterAreaDescription] = useState(null);
  const [subAreaId, setSubAreaId] = useState(null);
  const [subAreaDescription, setSubAreaDescription] = useState(null);
  const [masterArea, setMasterArea] = useState(null);
  const [subArea, setSubArea] = useState(null);
  const [masterAreaDropdownPayload, setMasterAreaDropdownPayload] = useState(
    []
  );
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [subAreaDropdownPayload, setSubAreaDropdownPayload] = useState([]);
  const [showMasterArea, setShowMasterArea] = useState(false);
  const [showSubArea, setShowSubArea] = useState(false);
  const [masterAreaObj, setMasterAreaObj] = useState(null);
  const [dynamicAttributeValueMap, setDynamicAttributeValueMap] = useState({});
  const [errors, setErrors] = useState({});
  const[departmentSelected, setDepartmentSelected] = useState(false);
    const [spanComponent, setSpanComponent] = useState(<>No File Chosen</>);

  const { fetchData: getProcessCondition } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getProcessConditionURL}`,
    body: processConditionFetchPayload,
    method: "post",
    headers: headers,
    onLoad: false,
  });
  const { fetchData: fetchInternalDepartmentList } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getInternalDepartment}`,
    method: "post",
    body: null,
    headers: headers,
    onLoad: false,
  });

  const rolesNew = useSelector(
    (state) => state.role.userCurrRole.department.id
  );
  const [autoId, setAutoId] = useState(rolesNew);
  const getFeedbackDescriptionTemplateURL =
    apiHostUrl + homeLink + getFeedbackDescriptionTemplate;
  const [addGetClientsPayload, setAddGetClientsPayload] = useState({
    department: { id: null },
  });
  const { fetchData: getFeedbackDescriptionTemplatefunc } = useAxiosFetchData({
    url: getFeedbackDescriptionTemplateURL,
    method: "post",
    body: addGetClientsPayload,
    headers: headers,
    onLoad: false,
  });
  const [feedbackDescTemplate, setFeedbackDescTemplate] = useState(null);
  const feedBackDescTemplateHandler = () => {
    console.log("hi");
    getFeedbackDescriptionTemplatefunc().then((data) => {
      setFeedbackDescTemplate(data);
      console.log(data);
    });
  };
  const [descriptionData, setDescription] = useState("");

  const [filterTemplate, setFilterTemplate] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const fileInputRef = useRef(null);
  useEffect(() => {
    const handleStorageChange = (event) => {
      console.log("Storage event detected:", event);
      console.log(
        "See I have changed ------>",
        htmlToPlainText(event.target.sessionStorage.editorContent)
      );
      setShowSuggestions(true);
      debugger;
      setDescription(
        htmlToPlainText(event.target.sessionStorage.editorContent).trim()
      );
      // Extract tokens from descriptionData, convert to lowercase
      const tokens = descriptionData
        .split(/\s+/)
        .map((token) => token.toLowerCase());
      debugger;
      // Filter feedbackDescTemplate based on token inclusion in item.description
      const filteredTemplate =
        feedbackDescTemplate?.filter((item) => {
          return tokens.some((token) => {
            const escapedToken = token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            const regex = new RegExp("\\b" + escapedToken + "\\b", "i");
            return regex.test(item.description);
          });
        }) || [];

      setFilterTemplate(filteredTemplate);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [descriptionData]);

  const [selectedTemplate, setSelectedTemplate] = useState(-1);

  const dispatch = useDispatch();
  const { addFeedbackOnSubmit } = useSelector(
    (state) => state.ResponsePendingReducer
  );
  const ref = useRef(null);
  // useEffect(()=>{
  //   if(dept!==null && dept !== undefined && dept !== "" && dept!==0){
  //     setProcessConditionFetchPayload({departmentId:`${dept}`})
  //   }
  // },[dept]);
  useEffect(() => {
    if (
      processConditionFetchPayload !== null &&
      processConditionFetchPayload !== undefined
    ) {
      getProcessCondition().then((response) => {
        console.log(response);
        if (response.length === 0) {
          setShowMasterArea(false);
          setShowSubArea(false);
          setProcessConditionId(null);
          setMasterAreaDropdownPayload([]);
          setSubAreaDropdownPayload([]);
          setProcessConditionName(null);
          setAddFeedbackWithAreaEnable(false);
          return;
        }
        response?.map((item, index) => {
          setProcessConditionId(item.processConditionId);
          setProcessConditionName(item.processConditionName);
        });
      });
    }
  }, [processConditionFetchPayload]);
  const [departmentListforInternal, setDepartmentforInternal] = useState(null);
  useEffect(() => {
    // feedBackDescTemplateHandler();
    fetchInternalDepartmentList().then((response) => {
      console.log(response);
      setDepartmentforInternal(
        response.map((item) => ({ desc: item.description, id: item.id }))
      );
      debugger;
    });
  }, []);
  const { fetchData: getAreaByFeedbackType } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getAreaByFeedbackTypeURL}/${dept}/${feedbackType}/${processConditionId}`,
    body: {},
    method: "post",
    headers: headers,
    onLoad: false,
  });
  useEffect(() => {
    if (
      processConditionId !== null &&
      processConditionId !== undefined &&
      feedbackType !== null
    ) {
      getAreaByFeedbackType().then((response) => {
        console.log(response);
        setShowMasterArea(true);
        setMasterAreaDropdownPayload([]);
        response.map((item, index) => {
          setMasterAreaDropdownPayload((prev) => [
            ...prev,
            { id: item.id, desc: item.description },
          ]);
        });
      });
    }
  }, [processConditionId, feedbackType]);
  const [subAreaPayload, setSubAreaPayload] = useState(null);
  const { fetchData: getSubAreaByFeedbackType } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getSubAreaURL}`,
    body: subAreaPayload,
    method: "post",
    headers: headers,
    onLoad: false,
  });

  useEffect(() => {
    setMasterAreaId(null);
  }, [dept]);
  useEffect(() => {
    if (showSubArea === true) {
      setSubAreaPayload({ id: masterAreaId, department: { id: dept } });
    }
  }, [showSubArea, masterAreaId]);

  useEffect(() => {
    if (
      subAreaPayload !== null &&
      subAreaPayload !== undefined &&
      subAreaPayload.id !== null &&
      subAreaPayload.id !== undefined &&
      subAreaPayload.id !== ""
    ) {
      getSubAreaByFeedbackType().then((response) => {
        console.log(response);
        setShowSubArea(true);
        response.map((item, index) => {
          setSubAreaDropdownPayload((prev) => [
            ...prev,
            { id: item.subAreaId, desc: item.description },
          ]);
        });
      });
    }
  }, [subAreaPayload?.id]);

  useEffect(()=>{
      if (subAreaDropdownPayload.length == 1) {
              setSubAreaId(subAreaDropdownPayload[0].id);
          }
  },[subAreaDropdownPayload])

  useEffect(() => {
    if (!ftDone) {
      setftDone(true);
      fetchFeedbackTypeList().then((response) => {
        setftDone(true);
        //debugger;
        if (
          response &&
          response.feedbackTypeList &&
          response.feedbackTypeList.length > 0
        ) {
          setFeedbackTypeList(
            response.feedbackTypeList.map((item, index) => ({
              id: item.feedbackTypeId,
              desc: item.feedbackTypeDesc.trim(), // Trim to remove leading/trailing whitespaces
            }))
          );
        }
        setAddFeedbackWithAreaEnable(response?.addFeedbackWithAreaEnable);
      });
    }
  }, [fetchFeedbackTypeList, ftDone]);

  const multiPartHeaders = {
    "Content-Type": "multipart/form-data",
    "X-CSRF-TOKEN": csrfToken,
  };

  const uploadFeedbackAttachemtURL =
    apiHostUrl + homeLink + uploadFeedbackAttachment;
  const formData = new FormData();
  //formData.append("hiddenBidderId", bidderId);
  formData.append("_csrf", csrfToken);
  formData.append("_csrf", csrfToken);
  formData.append("fileName", "");
  formData.append("tagOldFeedback", "");
  debugger;
  const assignedDepartmentDesc = roles
    .filter((role) => {
      return role.department.description !== null && role.department.id !== 189;
    })
    .reduce((map, role) => {
      map.set(role.department.description, role.department.id);
      return map;
    }, new Map());
  const [assignedDepartment, ___] = useState(
    [...assignedDepartmentDesc.entries()].map(([k, v]) => ({ desc: k, id: v }))
  );

  /*const handleFileNameChange = (val) => {
    debugger;
    console.log(val);
    setFilename(val.toString());
  };*/

  const handleFileNameChange = (event) => {
    const files = event?.target?.files;
    if (selectedFiles.length > 0) {
      const fileNames = selectedFiles.map(file => file.name).join(", ");
      setFilename(fileNames);
    } else {
      setFilename(t('general.label.no.file.chosen')); // fallback text if none selected
    }
  };
  
  const onclickFeedbackTypeHandler = useCallback((option) => {
    debugger;
    setMasterAreaId(null);
    setSubAreaDropdownPayload([]);
    setShowSubArea(false);
    setErrors({});
    setFeedbackType(option);
    if (option == 103) {
      setSelectedType(true);
    } else {
      setSelectedType(false);
    }
    /*if (assignedDepartment.length === 1) {
      onclickDepartmentHandler(assignedDepartment[0]);
      // debugger;
    }*/

    // console.log(Array.from(assignedDepartmentDesc.keys()));
  }, []);
  useEffect(() => {
    if (assignedDepartment.length === 0) {
      assignedDepartment.push({ desc: "Admin", id: 112 });
    }
  }, [assignedDepartment]);

  const handleRadioClick = (id) => {
    setFeedbackType(id);
    console.log(id);
    if (id == 103) {
      setSelectedType(true);
    } else {
      setSelectedType(false);
    }
    setSelectedType(true);
    if (assignedDepartment.length === 1) {
      onclickDepartmentHandler(assignedDepartment[0]);
    }
  };
  const onclickDepartmentHandler = useCallback((deptObj) => {
    setFeedbackTypeList([]);
    setDepartmentSelected(true);
    setDynamicAttributeValueMap({});
    setErrors({});
    setFinalPayload({ ["attributeList"]: [] });
    console.log(deptObj?.id + " " + deptObj?.desc);
    debugger;
    if (deptObj === null || deptObj === undefined || deptObj === "") {
      setDept("");
      setFeedbackListPayload(dept);
      return;
    } else if (deptObj.id === 189 || deptObj.id === "189") {
      if (homeLink === "/internal")
        setProcessConditionFetchPayload({ departmentId: 112 });
      setDept(112);
      fetchDepartmentAttributes(112);
      setAddGetClientsPayload({
        department: { id: 112 },
      });
      // feedBackDescTemplateHandler();
      setFeedbackListPayload({ serviceId: 112 });

      return;
    } else if (
      deptObj.id === 111 ||
      deptObj.id === 116 ||
      deptObj.id === 126 ||
      deptObj.id === 128
    ) {
      setDept(112);
      setFeedbackListPayload({ serviceId: 112 });
      fetchDepartmentAttributes(112);
      setAddGetClientsPayload({
        department: { id: 112 },
      });
      // feedBackDescTemplateHandler();
      return;
    }
    setFeedbackListPayload({
      serviceId: deptObj?.id == 189 ? null : deptObj.id,
    });
    setDept(deptObj.id);
    if (homeLink === "/internal")
      setProcessConditionFetchPayload({ departmentId: deptObj.id });
    fetchDepartmentAttributes(deptObj.id);
    setAddGetClientsPayload({
      department: { id: deptObj.id },
    });
  });
  useEffect(() => {
    if (dept !== "") {
      feedBackDescTemplateHandler();

      // fetchOldFeedbacks();
      // if()
      debugger;
      fetchFeedbackTypeList().then((response) => {
        //console.log(response.addFeedbackWithAreaEnable);
        if (
          response &&
          response.feedbackTypeList &&
          response.feedbackTypeList.length > 0
        ) {
          setFeedbackTypeList(
            response.feedbackTypeList.map((item, index) => ({
              id: item.feedbackTypeId,
              desc: item.feedbackTypeDesc.trim(), // Trim to remove leading/trailing whitespaces
            }))
            // .filter((item) =>
            //   item.desc.toLowerCase().includes(feedbacktype.toLowerCase())
            // )
          );
        }
        setAddFeedbackWithAreaEnable(response?.addFeedbackWithAreaEnable);
      });
    }
  }, [dept]);
  const fetchOldFeedbacks = useCallback(() => {
    axios
      .post(
        API_Routes.getCustomerOldFeedbackList,
        { bidderId: bidderId, serviceId: dept },
        { headers: newHeaders, withCredentials: true }
      )
      .then((response) => {
        if (response.data.length === 0) {
          return;
        }
        response.data.map((feedback) => {
          setOldFeedbackList((prev) => [
            ...prev,
            { label: feedback.feedbackCode, desc: feedback.feedbackDesc },
          ]);
        });

        // console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  });
  const url = apiHostUrl + homeLink + getCustomerDepartmentAttributeMap;
  const fetchDepartmentAttributes = (deptId) => {
    console.log(deptId);
    axios
      .post(
        url,
        { serviceId: deptId },
        { headers: newHeaders, withCredentials: true }
      )
      .then((response) => {
        // console.log("Department Attribute Map ", response.data);
        // console.log("response status ", response.status);
        // console.log(response.headers);
        if (response.headers["content-type"].includes("text/html")) {
          console.log("Received HTML, refetching...");
          setTerminated(true);
          return;
        } else if (response.status === 200) {
          setDepartmentAttributeMap(response.data);
          debugger;
        }
        debugger;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getFeedbackTypeListURL = apiHostUrl + homeLink + getFeedbackTypeListAll;

  const getFeedbackTypeList = useCallback(() => {
    debugger;
    if (payload1 && payload1.serviceId) {
      axios
        .post(getFeedbackTypeListURL, payload1, {
          withCredentials: true,
          headers,
        })
        .then((data) => {
          console.log("hi");

          console.log(data.data.feedbackTypeList);
          // setFeedbackTypeList((data.data.feedbackTypeList).map((item, index) => item.feedbackTypeDesc));
          if (
            data?.data?.feedbackTypeList &&
            data.data.feedbackTypeList.length > 0
          ) {
            setFeedbackTypeList(
              data.data.feedbackTypeList.map((item, index) => ({
                id: item.feedbackTypeId,
                desc: item.feedbackTypeDesc.trim(), // Trim to remove leading/trailing whitespaces
              }))
              // .filter((item) =>
              //   item.desc.toLowerCase().includes(feedbacktype.toLowerCase())
              // )
            );
          }
          console.log(feedbackTypeList);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  });

  const validateForm = () => {
    let validatingError = {};

    if (dept == "" || dept == null) {
      validatingError.assignedDepartment = "Department is required";
    }
    debugger;

    if (feedbackType == "" || feedbackType == null) {
      console.log("I am in feedbackType" + feedbackType);
      validatingError.feedbackTypeId = "Feedback type is required";
    }

    var feedbackDescription = sessionStorage.getItem("editorContent");
    if (feedbackDescription && feedbackDescription.length > 0) {
      feedbackDescription = removeHTMLElements(feedbackDescription);
    }
    if (feedbackDescription === null || feedbackDescription == "") {
      console.log(
        "I am in feedback Discription" + sessionStorage.getItem("editorContent")
      );
      validatingError.feedbackDesc = "Feedback Description is required";
    }

    console.log(
      "departmentAttributeMap" + JSON.stringify(departmentAttributeMap)
    );

    Object.values(departmentAttributeMap).forEach((attribute) => {
      debugger;
      if (
        attribute.mandatory === "Y" &&
        !dynamicAttributeValueMap[attribute.attributeName]
      ) {
        validatingError[
          attribute.attributeName
        ] = `${attribute.attributeName} is required`;
      }
    });

    //File input validation
    //"addFileList[0].multipartFile"
    debugger;
    //var feedbackFiles = document.querySelectorAll(".feedback-comment-file-list");
    /*if (feedbackFiles && feedbackFiles.length > 0) {
      for (var i = 0; i < feedbackFiles.length; i++) {
        var fullPath = feedbackFiles[i].value;
        if (fullPath) {
          var startIndex =
            fullPath.indexOf("\\") >= 0
              ? fullPath.lastIndexOf("\\")
              : fullPath.lastIndexOf("/");
          var filename = fullPath.substring(startIndex);
          if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
            filename = filename.substring(1);
          }
          var fileErrors = [];
          checkImageSignatureAndSize(
            feedbackFiles[i],
            fileErrors,
            setErrors,
            validatingError
          );
          //debugger;
          if (fileErrors?.length > 0) {
            validatingError.fileUpload = fileErrors[0];
          }
        }
      }
    }*/

      if (selectedFiles && selectedFiles.length > 0) {
    selectedFiles.forEach((file, index) => {
      // Use a mock input-like object if needed
      const mockInput = { files: [file] };
      var fileErrors = [];
      checkImageSignatureAndSize(
        mockInput,
        fileErrors,
        setErrors,
        validatingError,
        selectedFiles
      );

      if (fileErrors?.length > 0) {
        validatingError.fileUpload = fileErrors[0];
      }
    });
  }
    
    if(masterAreaId!==null && subAreaId===null){
      validatingError.subArea = "Subarea is required";
    }
    debugger;
    setErrors(validatingError);
    return Object.keys(validatingError).length === 0;
  };

  const submitFeedbackHandler = () => {
    debugger;
    if (validateForm()) {
      debugger;
      // if (
      //   attributeList.length === 0 &&
      //   (required > 0 ||
      //     sessionStorage.getItem("editorContent").length <= 0 ||
      //     (addFeedbackWithAreaEnable === true &&
      //       processConditionId !== null &&
      //       ((masterAreaId !== null && masterAreaId !== undefined) &&
      //         (subAreaId === null ||
      //           subAreaId === undefined))))
      // ) {
      //   alert(t("general.label.mandatory.fields"));
      //   return;
      // }
      setSubmitButtonDisabled(true);
      let tagFeedbackList = "";
      oldFeedbackList.forEach((feedback) => {
        tagFeedbackList += feedback.feedbackCode + ",";
      });
      const payload = {
        feedbackDesc: sessionStorage.getItem("editorContent"),
        feedbackFile: feedbackFile,
        tagOldFeedback: tagFeedbackList,
        feedbackTypeId: feedbackType,
        serviceId: dept,
        fileName: filename,
        attributeList: finalPayload,
        bidderId: bidderId,
        areaId: masterAreaId,
        subAreaId: subAreaId,
        processConditionId: processConditionId,
        processConditionName: processConditionName,
        feedbackSourceId: "100",
      };

      // New FormData to append file and user data
      let formData = new FormData();

      //File input
      //"addFileList[0].multipartFile"
      debugger;
      /*var feedbackFiles = document.querySelectorAll(".feedback-comment-file-list");
      if (feedbackFiles && feedbackFiles.length > 0) {
        for (var i = 0; i < feedbackFiles.length; i++) {
          var fullPath = feedbackFiles[i].value;
          if (fullPath) {
            var startIndex =
              fullPath.indexOf("\\") >= 0
                ? fullPath.lastIndexOf("\\")
                : fullPath.lastIndexOf("/");
            var filename = fullPath.substring(startIndex);
            if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
              filename = filename.substring(1);
            }
            //alert(filename);
            if (filename) {
              formData.append(
                "addFileList[" + i + "].multipartFile",
                feedbackFiles[i].files[0]
              );
              formData.append("addFileList[" + i + "].fileName", filename);
            }
          }
        }
      }*/

      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file, index) => {
          formData.append(`addFileList[${index}].multipartFile`, file);
          formData.append(`addFileList[${index}].fileName`, file.name);
        });
      }

      //formData.append("addFileList", filename);
      // for (let files of filename) {
      // }
      //User data
      //formData.append("userData", JSON.stringify(payload));
      formData.append("feedbackDescriptionTemplateId", selectedTemplate);
      formData.append("_csrf", csrfToken);
      formData.append("feedbackDesc", sessionStorage.getItem("editorContent"));
      formData.append("feedbackTypeId", feedbackType);
      formData.append("serviceId", dept);
      formData.append("feedbackSourceId", 100);
      if (
        addFeedbackWithAreaEnable === true &&
        processConditionId !== null &&
        masterAreaId !== null &&
        subAreaId !== null &&
        processConditionId !== null
      ) {
        formData.append("areaId", masterAreaId);
        formData.append("subAreaId", subAreaId);
        formData.append("processConditionId", processConditionId);
        formData.append("processConditionName", processConditionName);
        formData.append("feedbackSourceId", 100);
      }
      feedbackFile && formData.append("feedbackFile", feedbackFile);
      tagFeedbackList && formData.append("tagOldFeedback", tagFeedbackList);
      filename && formData.append("fileName", filename);
      //formData.append("attributeList", JSON.stringify(attributeList));
      //bidderId && formData.append("bidderId", bidderId);
      debugger;
      if (finalPayload.attributeList && finalPayload.attributeList.length > 0) {
        for (var i = 0; i < finalPayload.attributeList.length; i++) {
          formData.append(
            "attributeList[" + i + "].departmentAttributeId",
            finalPayload.attributeList[i].departmentAttributeId
          );
          formData.append(
            "attributeList[" + i + "].attributeType",
            finalPayload.attributeList[i].attributeType
          );
          formData.append(
            "attributeList[" + i + "].attributeId",
            finalPayload.attributeList[i].attributeId
          );
          formData.append(
            "attributeList[" + i + "].mandatory",
            finalPayload.attributeList[i].mandatory
          );
          formData.append(
            "attributeList[" + i + "].attributeVal",
            finalPayload.attributeList[i].attributeVal
          );
        }
      }
      dispatch(setResponsePendingReducer({ addFeedbackOnSubmit: true }));
      axios
        .post(`${apiHostUrl}${homeLink}${addFeedbackUrl}`, formData, {
          withCredentials: true,
          headers: multiPartHeaders,
        })
        .then((data) => {
          console.log(data);
          dispatch(setResponsePendingReducer({ addFeedbackOnSubmit: false }));
          //debugger;
          if (data?.data?.success) {
            console.log("Feedback added successfully");

            snackbarSwitchHandler(true);
            snackMsgHandler(
              t("general.label.feedback.code") +
                data.data.feedbackCode +
                t("general.label.note.feedback.code")
            );
            setAddFeedbackResult(data.data);
            setOpen(true);
            resetForm();
            setRefreshDashboard(false);
            setRefreshDashboard(true);
            //postActionDataRefresh(2, setRefreshDashboard);
            onModalCloseHandler();
          }
          // } else {
          //   snackbarSwitchHandler(true);
          //   snackMsgHandler(t("general.label.unfortunately.no.feedback.submit"));
          //   onModalCloseHandler();
          // }
        })
        .catch((error) => {
          console.log(error);
          snackbarSwitchHandler(true);
          snackMsgHandler(t("general.label.unfortunately.no.feedback.submit"));
          onModalCloseHandler();
        });
      // setOpen(true);
    } else {
      ref.current?.scrollIntoView({ behaviour: "smooth" });
    }
  };
  const oldFeedbackValueChange = (event, value) => {
    console.log(event, " ", value);
    setOldFeedbacks((prev) => {
      return { ...prev, value };
    });
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    resetForm();
    setOpen(false);
  };
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  const resetForm = () => {
    console.log("Reset= ", r);
    setDept("");
    setFeedbackType(null);
    sessionStorage.setItem("editorContent", "");
    setR((prev) => prev + 1);
    setFinalPayload({ ["attributeList"]: [] });
    setDepartmentAttributeMap([]);
    setErrors({});
    setDynamicAttributeValueMap({});
    setFeedbackFile("");
    setFilename("");
    setOldFeedbacks([]);
    console.log("Reset= ", r);
  };
  useEffect(() => {
    debugger;
    console.log("----------------------------");
    console.log("Department ", dept);
    console.log("Feedback Type ", feedbackType);
    console.log("----------------------------");
    getFeedbackTypeList();
    if (initLoad) {
      console.log("dd", feedbackTypeList);

      // onclickFeedbackTypeHandler(feedbackTypeList[0].id);
      setInitLoad(false);
    }

    if (dept && feedbackType) {
      console.log("----------------------------");
      console.log("Attribute List ", finalPayload);
      console.log("----------------------------");
    }
  }, [r]);
  const handleDynamicAttributeChange = (val, attribute) => {
    debugger;
    if (val === null || val === "-1" || val === "") {
      const { [attribute.attributeName]: _, ...rest } =
        dynamicAttributeValueMap;
      setDynamicAttributeValueMap(rest);
      setDataToPayload("", attribute);
    } else {
      setDynamicAttributeValueMap({
        ...dynamicAttributeValueMap,
        [attribute.attributeName]: val,
      });
      const {
        [attribute.departmentAttributeId]: _,
        [attribute.attributeName]: __,
        ...rest
      } = errors;
      setErrors(rest);
      setDataToPayload(
        val.departmentAttributeValId ? val.departmentAttributeValId : val,
        attribute
      );
    }
  };

  const handleFileChange = (event, labelSelector) => {
    debugger;
    const files = event?.target?.files;
    const newFiles = Array.from(event?.target?.files || []);
    const mergedFiles = [...selectedFiles, ...newFiles];
    setSelectedFiles(mergedFiles);
    if (event && event.target) {
      const parent1 = event.target.parentElement;
      const parent2 = parent1?.parentElement;

      if (labelSelector && parent2) {
        const labelEl = parent2.querySelector(labelSelector);
        if (labelEl) {
          if (mergedFiles.length > 0) {
            //         const fileNames = mergedFiles.map(file => file.name).join(", ");
            let span = mergedFiles.map(file => {
              return <div
                data-file-name="true"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
                className="multi-attachment-select">
                {file.name}
                <div
                  data-filename="${file.name}"
                  onClick={(e) => { e.stopPropagation(); handleRemoveFile(e, file.name); }}
                  className="remove-file-cross">&times;</div>
              </div>
            }

            );
            setSpanComponent(span);
          } else {
            labelEl.innerHTML = t('general.label.no.file.chosen');
          }
        }
      }
    }
  };

   const handleRemoveFile = (e, fileNameToRemove) => {
      debugger;
    setSelectedFiles(prev =>
      prev.filter(file => file.name !== fileNameToRemove)
    );
    if (fileInputRef.current) {
    fileInputRef.current.value = "";
    }
    };
  
    useEffect(() => {
      debugger;
      console.log("selectedFiles: "+selectedFiles);
      if (selectedFiles.length > 0) {
        //         const fileNames = mergedFiles.map(file => file.name).join(", ");
        let span = selectedFiles.map(file => {
          return <div className="multi-attachment-select">
            {file.name}
            <div
              data-filename="${file.name}"
              onClick={(e) => { e.stopPropagation(); handleRemoveFile(e, file.name); }}
              className="remove-file-cross">&times;</div>
          </div>
        });
        setSpanComponent(span);
      } else{
        setSpanComponent(<div className="multi-no-file-choosen">{t('general.label.no.file.chosen')}</div>);
      }
        }, [selectedFiles])
  
  const setDataToPayload = (val, attribute) => {
    debugger;
    var finalAttributeList = finalPayload.attributeList;
    var payloadContainsList = false;
    finalAttributeList.forEach((item) => {
      if (item.attributeName === attribute.attributeName) {
        payloadContainsList = true;
      }
    });

    if (payloadContainsList && val != "") {
      console.log(finalPayload);
      setFinalPayload((prev) => ({
        ...prev,
        attributeList: prev.attributeList.map((item) => {
          if (item.attributeName === attribute.attributeName) {
            return {
              ...item,
              attributeVal: val,
            };
          }
          return item;
        }),
      }));
    } else {
      if (val !== "") {
        const newData = {
          attributeType: attribute.attributeType,
          departmentAttributeId: attribute.departmentAttributeId || "",
          attributeId: attribute.attributeId || "",
          mandatory: attribute.mandatory || "",
          attributeName: attribute.attributeName || "",
          attributeVal: val || "",
        };
        finalAttributeList.push(newData);
        setFinalPayload((prev) => ({
          ...prev,
          attributeList: finalAttributeList,
        }));
      } else {
        var filteredFinalAttributeList = finalAttributeList.filter(
          (item) => item.attributeName !== attribute.attributeName
        );
        setFinalPayload((prev) => ({
          ...prev,
          attributeList: filteredFinalAttributeList,
        }));
      }
    }
  };

  var minInputValReq = minInputValueForClientField;
  return (
    <div ref={ref}>
      {/* <PageHeadContainer pageTitle={path[path.length - 1]} pathArray={path}></PageHeadContainer> */}
      <Row>
        <Col lg="12">
        {departmentSelected && (
          <div key={`inline-radio`} className="mb-3 text-black">
            {feedbackTypeList &&
              feedbackTypeList?.map((type, index) => (
                <Form.Check
                  key={index}
                  inline
                  name="group1"
                  type={"radio"}
                  id={type.id}
                  label={type.desc}
                  onClick={() => onclickFeedbackTypeHandler(type.id)}
                />
              ))}
          </div>
        )}
          {errors.feedbackTypeId && (
            <span className="text-danger">{errors.feedbackTypeId}</span>
          )}
        </Col>

        <Col lg="12">
          {departmentListforInternal && (departmentListforInternal.length >1 || assignedDepartment.length > 1) && (
            <FormRow>
              <TextLabel
                title={t("label.department.description")}
                isMandatory={true}
              ></TextLabel>
              <Dropdown
                isDisabled={false}
                title={"Choose"}
                items={
                  homeLink === "/internal"
                    ? departmentListforInternal
                    : assignedDepartment
                }
                onChange={onclickDepartmentHandler}
              ></Dropdown>
              {errors.assignedDepartment && (
                <span className="text-danger">{errors.assignedDepartment}</span>
              )}
            </FormRow>
          )}

          {/* <FormRow>
            <TextLabel
              title={t('general.lable.select.feedbackType.text')}
              isMandatory={true}
            ></TextLabel>
            <Dropdown isDisabled={required > 2} isMandatory={true} title="Choose" items={feedbackTypeList} onChange={onclickFeedbackTypeHandler}></Dropdown>
          </FormRow> */}
        </Col>

        <Col lg="6">
          {(departmentAttributeMap !== null ||
            departmentAttributeMap !== undefined) &&
            Object.values(departmentAttributeMap).map((attribute, index) => (
              <Form.Group className="mb-3" controlId="status">
                <TextLabel
                  className="testingStars "
                  title={attribute.attributeName}
                  isMandatory={attribute.mandatory === "Y" ? true : false}
                ></TextLabel>
                {attribute.attributeType === "LIST" &&
                  attribute.autoComplete === true && (
                    <Form.Group>
                      <Autocomplete
                        disablePortal
                        id="autoCompleteDropdown"
                        value={
                          dynamicAttributeValueMap.hasOwnProperty(
                            attribute.attributeName
                          )
                            ? dynamicAttributeValueMap[attribute.attributeName]
                            : null
                        }
                        options={attribute.attributeMasterValueList.sort(
                          (a, b) => {
                            // Function to normalize and prepare strings for comparison
                            const normalizeString = (str) => {
                              return str.trim().toLowerCase(); // Trim whitespace and convert to lowercase
                            };

                            // Normalize both attribute values
                            let attributeValA = normalizeString(a.attributeVal);
                            let attributeValB = normalizeString(b.attributeVal);

                            // Compare normalized attribute values
                            if (attributeValA < attributeValB) {
                              return -1; // A should come before B
                            } else if (attributeValA > attributeValB) {
                              return 1; // B should come before A
                            } else {
                              return 0; // A and B are equal
                            }
                          }
                        )}
                        getOptionLabel={(option) =>
                          option?.desc ? option.desc : option.attributeVal
                        }
                        onChange={(event, newValue) => {
                          console.log(newValue);
                          newValue !== null
                            ? handleDynamicAttributeChange(newValue, attribute)
                            : handleDynamicAttributeChange(null, attribute);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                        sx={{ minWidth: "10vw", height: "auto" }}
                        clearIcon={false}
                        filterOptions={(options, state) => {
                          if (state.inputValue.length < minInputValReq) {
                            return [];
                          } else {
                            const filteredOptions = options.filter((ele) =>
                              ele?.desc
                                ? ele.desc
                                    .toLowerCase()
                                    .includes(state.inputValue.toLowerCase())
                                : ele.attributeVal
                                    .toLowerCase()
                                    .includes(state.inputValue.toLowerCase())
                            );
                            if (filteredOptions.length === 0) {
                              return [
                                {
                                  attributeVal: -1,
                                  desc: "No data was found",
                                  attributeName: "",
                                },
                              ];
                            } else {
                              return filteredOptions;
                            }
                          }
                        }}
                        noOptionsText={t("min.letter.required", {
                          num: minInputValReq,
                        })}
                        disable
                        getOptionDisabled={(option) =>
                          option.attributeVal === -1
                        }
                      />
                      {errors[attribute?.attributeName] && (
                        <span className="text-danger">
                          {errors[attribute?.attributeName]}
                        </span>
                      )}
                    </Form.Group>
                  )}
                {attribute.attributeType === "LIST" &&
                  attribute.autoComplete === false && (
                    <Form.Group>
                      <Form.Select
                        value={
                          dynamicAttributeValueMap.hasOwnProperty(
                            attribute.attributeName
                          )
                            ? dynamicAttributeValueMap[attribute.attributeName]
                            : "-1"
                        }
                        onChange={(e) =>
                          handleDynamicAttributeChange(
                            e.target.value,
                            attribute
                          )
                        }
                      >
                        <option value="-1">
                          Select {attribute.attributeName}
                        </option>
                        {attribute.attributeMasterValueList.map((item) => (
                          <option
                            key={item.departmentAttributeValId}
                            value={item.departmentAttributeValId}
                          >
                            {item.attributeVal}
                          </option>
                        ))}
                      </Form.Select>

                      {errors[attribute?.attributeName] && (
                        <span className="text-danger">
                          {errors[attribute?.attributeName]}
                        </span>
                      )}
                    </Form.Group>
                  )}

                {attribute.attributeType === "DATE" && (
                  <Form.Group>
                    {/* <TextLabel
                                className="testingStars "
                                title={attribute.attributeName}
                                isMandatory={(attribute.mandatory === 'Y') ? true : false}
                              ></TextLabel> */}
                    <DatePickerComponent
                      isMandatory={attribute.mandatory == "Y" ? true : false}
                      defaultValue={
                        dynamicAttributeValueMap.hasOwnProperty(
                          attribute.attributeName
                        )
                          ? dynamicAttributeValueMap[attribute.attributeName]
                          : null
                      }
                      width={"-webkit-fill-available"}
                      onChange={(e) =>
                        handleDynamicAttributeChange(e, attribute)
                      }
                      attribute={attribute}
                    ></DatePickerComponent>
                    {errors[attribute?.attributeName] && (
                      <span className="text-danger">
                        {errors[attribute?.attributeName]}
                      </span>
                    )}
                  </Form.Group>
                )}
                {attribute.attributeType === "INPUT" && (
                  <Form.Group>
                    <TextLabel
                      className="testingStars "
                      value={
                        dynamicAttributeValueMap.hasOwnProperty(
                          attribute.attributeName
                        )
                          ? dynamicAttributeValueMap[attribute.attributeName]
                          : null
                      }
                      title={attribute.attributeName}
                      isMandatory={attribute.mandatory === "Y" ? true : false}
                    ></TextLabel>
                    <Form.Control
                      type="text"
                      placeholder={`Enter ${attribute.attributeName}`}
                      isMandatory={attribute.mandatory == "Y" ? true : false}
                      onChange={(e) =>
                        handleDynamicAttributeChange(e.target.value, attribute)
                      }
                    />
                    {errors[attribute?.attributeName] && (
                      <span className="text-danger">
                        {errors[attribute?.attributeName]}
                      </span>
                    )}
                  </Form.Group>
                )}
                {attribute.attributeType === "text" && (
                  <Form.Group>
                    <Form.Control
                      as="input"
                      type="text"
                      value={
                        dynamicAttributeValueMap.hasOwnProperty(
                          attribute.attributeName
                        )
                          ? dynamicAttributeValueMap[attribute.attributeName]
                          : ""
                      }
                      rows={3}
                      placeholder={`Enter ${attribute.attributeName}`}
                      onChange={(e) =>
                        handleDynamicAttributeChange(e.target.value, attribute)
                      }
                    />
                    {errors[attribute?.attributeName] && (
                      <span className="text-danger">
                        {errors[attribute?.attributeName]}
                      </span>
                    )}
                  </Form.Group>
                )}
                {attribute.attributeType === "INT" && (
                  <Form.Group>
                    <TextLabel
                      className="testingStars "
                      title={attribute.attributeName}
                      value={
                        dynamicAttributeValueMap.hasOwnProperty(
                          attribute.attributeName
                        )
                          ? dynamicAttributeValueMap[attribute.attributeName]
                          : null
                      }
                      isMandatory={attribute.mandatory === "Y" ? true : false}
                    ></TextLabel>
                    <Form.Control
                      type="number"
                      placeholder={`Enter ${attribute.attributeName}`}
                      onChange={(e) =>
                        handleDynamicAttributeChange(e.target.value, attribute)
                      }
                    />
                    {errors[attribute?.attributeName] && (
                      <span className="text-danger">
                        {errors[attribute?.attributeName]}
                      </span>
                    )}
                  </Form.Group>
                )}
                {errors.dynamicFieldData && (
                  <span className="text-danger">{errors.dynamicFieldData}</span>
                )}
              </Form.Group>
            ))}
        </Col>
        <Col lg="12">
          <Form.Group className="mb-3">
            <TextLabel
              title={t("feedbackDetails.feedbackDescription.text")}
              isMandatory={true}
            ></TextLabel>
            {/* <Textarea></Textarea> */}
            <RichTextEditor
              reset={r}
              updateEditor={updateEditorExternal}
            ></RichTextEditor>
            {errors.feedbackDesc && (
              <span className="text-danger">{errors.feedbackDesc}</span>
            )}
          </Form.Group>

          {/* <FormRow>
          
          <RichTextEditor reset={r}></RichTextEditor>
        </FormRow> */}
        </Col>

        {showSuggestions &&
          feedbackDescTemplate &&
          feedbackDescTemplate.length > 0 &&
          descriptionData.length >= 3 &&
          filterTemplate.length > 0 && (
            <Col lg="12">
              <div class="list-group mb-3">
                {filterTemplate.map((item, index) => {
                  return (
                    <button
                      onClick={(event) => {
                        // setFilterTemplate([]);
                        setShowSuggestions(false);
                        console.log("Onclick template", event);
                        console.log(item.feedbackDescriptionTemplateId);
                        setSelectedTemplate(item.feedbackDescriptionTemplateId);
                        // sessionStorage.setItem(
                        //   "editorContent",
                        //   item.description
                        // );
                        // window.dispatchEvent(new Event("storageEdit"));
                        // updateEditorExternal(item.description);
                        const externalTextEditorChangeEvent = new CustomEvent(
                          "storageEditExternal",
                          {
                            bubbles: true,
                            cancelable: true,
                            detail: item.description,
                          }
                        );
                        window.dispatchEvent(externalTextEditorChangeEvent);
                        // setDescription("");
                        //
                      }}
                      class="list-group-item list-group-item-action"
                      aria-current="true"
                    >
                      {item.description}
                    </button>
                  );
                })}
                {/* <a href="#" class="list-group-item list-group-item-action" aria-current="true">
              The current link item
            </a>
            <a href="#" class="list-group-item list-group-item-action">A second link item</a>
            <a href="#" class="list-group-item list-group-item-action">A third link item</a>
            <a href="#" class="list-group-item list-group-item-action">A fourth link item</a>
            <a class="list-group-item list-group-item-action disabled" aria-disabled="true">A disabled link item</a> */}
              </div>
            </Col>
          )}

        <Col lg="12">
          <Form.Group controlId="formFile" className="mb-3">
            <TextLabel
              title={t("general.button.uploadFile")}
              isMandatory={false}
              // subLabel={
              //   " .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml"
              // }
            ></TextLabel>
            <span className="ms-2 fs-8">
              (.jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt,
              .pptx, .zip, .rar, .xml, .xps, .msg, .eml)
            </span>
            <br />

            {/* <Button variant="outline-primary" className="float-end py-0 mb-1" size="sm">
              <i class="ti ti-plus"></i> Add More
            </Button> */}

            <Form.Label className={"fw-medium feedback-add-files"}>
              {" "}
              {t("general.error.chooseFile.size")}{" "}
            </Form.Label>
            <InputGroup className="custom-file-uploader">
              <InputGroup.Text
                id="basic-addon1"
                onClick={(e) => clickFileInput(e, ".feedback-comment-file-list")}
                className="text-section float-start start-0 w-100 bg-body-secondary p-0 z-0 position-relative rounded"
              >
                <div className="p-2 me-2 border-end bg-body-secondary">
                  {t("general.label.choose.file")}
                </div>
                 <div className="file-name-label-span">
                    {spanComponent}
                  </div>
              </InputGroup.Text>
              {/* <FileUpload
                className={"feedback-add-file-list d-none"}
                fileTypes={
                  " .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml"
                }
                bidderId={bidderId}
                data={formData}
                onChange={(e) => {
                  handleFileChange(e, ".file-name-label");
                  handleFileNameChange(e);
                }}
                fetchUrl={uploadFeedbackAttachemtURL}
              ></FileUpload> */}
              <input
                  ref={fileInputRef}
                  type="file"
                  multiple
                  accept=" .jpg,.jpeg,.gif,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.xml,.xps,.msg,.eml"
                  data={formData}
                  className="feedback-comment-file-list d-none"
                  onChange={(e) => {
                    handleFileChange(e, ".file-name-label");
                    handleFileNameChange(e);
                  }}
              />
              {/* <span
                onClick={(e) => clearFileInput(e, ".feedback-add-file-list")}
                className="py-1"
              >
                <Button
                  variant="link"
                  className="border-0 text-decoration-none"
                >
                  <i class="ti ti-x"></i>
                </Button>
              </span> */}
            </InputGroup>
            {errors.fileUpload && (
              <span className="text-danger">{errors.fileUpload}</span>
            )}
            {/* <Form.Control type="file"  bidderId={bidderId} data={formData} onChange={handleFileChange} fetchUrl={uploadFeedbackAttachemtURL} /> */}
          </Form.Group>
          {/* <FormRow>
            <TextLabel
              title={t('general.button.uploadFile')}
              isMandatory={false}
              subLabel={" .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml"}
            ></TextLabel>
            <FileUpload fileTypes={" .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml"}
              bidderId={bidderId} data={formData} onChange={handleFileChange} fetchUrl={uploadFeedbackAttachemtURL}
            ></FileUpload>
          </FormRow> */}
        </Col>

        <Col lg="12" className="mb-3">
          {/* <Form.Group controlId="formFile" className="mb-3">
            <Form.Label className='fw-medium'>Want To Refer Previous Similar Feedback/Complaint?(Please type Feedback Code/Description/Date)</Form.Label>
            <Form.Select aria-label="Default select example">
              <option>Open this select menu</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </Form.Select>
          </Form.Group> */}
          <TextLabel
            title={t("general.label.similarFeedbackCode")}
            isMandatory={false}
          ></TextLabel>
          <TagOldFeedback
            id={dept}
            feedbackId={null}
            url={`${apiHostUrl}${homeLink}${getOldFeedbackSPOCUrl}`}
            feedbackBidderId={bidderId}
            oldFeedbackValueChange={(list) => {
              setOldFeedbackList(list);
            }}
            taggedFeedbackList={[]}
            newFeedback
          ></TagOldFeedback>
        </Col>
        {homeLink === "/internal" &&
          addFeedbackWithAreaEnable === true &&
          processConditionId && (
            <>
              <Col lg="6">
                {/* {showMasterArea && */}
                {
                  true && (
                    <DropdownInputWithLabel
                      label={t("menu.key.master.area")}
                      dropdownItems={masterAreaDropdownPayload}
                      isMandatory={false}
                      onDropdownChangeHandler={(event, mode) => {
                        console.log(event, mode);
                        if(event.target.value==="-1"){
                          setMasterAreaId(null);
                          setSubAreaDropdownPayload([]);
                          setShowSubArea(false);
                          setErrors({});
                          return;
                        }
                        setMasterAreaId(event.target.value);
                        setSubAreaDropdownPayload([]);
                        setShowSubArea(true);
                      }}
                      disabled={showMasterArea ? false : true}
                    />
                  )
                  // <>
                  //     {/* <Form.Label className='font-weight-bold'>{t("menu.key.master.area")}</Form.Label> */}
                  //     <TextLabel title={t("menu.key.master.area")} isMandatory></TextLabel>
                  //     <Form.Select   onChange={onMasterAreaChangeHandler} aria-label="Default select example" disabled={showMasterArea?false:true}>
                  //         <option></option>
                  //         {masterAreaDropdownPayload.map((item, index) => {
                  //             return (<option key={index} value={item.id}> {item.desc}
                  //             </option>)
                  //         })}
                  //     </Form.Select>
                  // </>
                }
              </Col>
              <Col lg="6">
                {/* {showMasterArea && */}
                {
                  true && (
                    <>
                      <DropdownInputWithLabel
                        label={t("menu.key.sub.area")}
                        dropdownItems={subAreaDropdownPayload}
                        onDropdownChangeHandler={(event, mode) => {
                          console.log(event, mode);
                          if (event.target.value==="-1"){
                            setSubAreaId(null);
                            setErrors({});
                            return;
                            
                          }
                          setSubAreaId(event.target.value);
                          setErrors({});
                        }}
                        disabled={showSubArea ? false : true}
                      />
                      {errors.subArea && (
                        <span className="text-danger">{errors.subArea}</span>
                      )}
                    </>
                  )
                  // <>
                  //     {/* <Form.Label className='font-weight-bold'>{t("menu.key.master.area")}</Form.Label> */}
                  //     <TextLabel title={t("menu.key.master.area")} isMandatory></TextLabel>
                  //     <Form.Select   onChange={onMasterAreaChangeHandler} aria-label="Default select example" disabled={showMasterArea?false:true}>
                  //         <option></option>
                  //         {masterAreaDropdownPayload.map((item, index) => {
                  //             return (<option key={index} value={item.id}> {item.desc}
                  //             </option>)
                  //         })}
                  //     </Form.Select>
                  // </>
                }
              </Col>
            </>
          )}
        <Col lg={12} className="text-end">
          <Button
            variant="primary"
            onClick={() => submitFeedbackHandler()}
            disabled={addFeedbackOnSubmit}
          >
            {t("menu.key.feedback.add")}{" "}
            {addFeedbackOnSubmit && (
              <span className="spinner-border spinner-border-sm ml-2"></span>
            )}
          </Button>
        </Col>

        {open && (
          <Snackbar
            open={open}
            autoHideDuration={100000}
            onClose={handleClose}
            message={
              t("general.label.feedback.code") +
              addFeedbackResult.feedbackCode +
              t("general.label.note.feedback.code")
            }
            action={action}
          />
        )}
      </Row>
    </div>
  );
}
function htmlToPlainText(html) {
  const tempElement = document.createElement("div");
  html = html.replace(/\n/g, " ");
  tempElement.innerHTML = html;
  return tempElement.textContent || tempElement.innerText || "";
}
export { htmlToPlainText };
